import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MessageStateModel } from '../../../store/store-models';
import { UserDataModel } from '@modules/auth';
import moment = require('moment');

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageItemComponent implements OnInit, AfterViewInit,  OnDestroy {
  @Input() message: MessageStateModel;
  @Input() lastUnreadIndex: number;
  @Input() author: UserDataModel;
  @Input() intersectionObserver: IntersectionObserver;
  @Input() @HostBinding('class.is-message-mine') isMessageMine: boolean;
  @HostBinding('attr.data-message-index') get messageIndex(): number {
    return this.message?.index;
  }

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.intersectionObserver?.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.intersectionObserver.unobserve(this.elementRef.nativeElement);
  }

  formattedDate(date: string | Date): string {
    if (!date) return '';

    moment.locale('en')
    const momentDate = moment(date, 'YYYY-MM-DDTHH:mm:ssZ', false);
    const duration = moment.duration(moment().utc().diff(momentDate));

    if (duration.asDays() < 1) {
      return momentDate.format('hh:mm A');
    }

    if (duration.asWeeks() < 1) {
      const days = Math.round(duration.asDays());
      return `${days} ${days === 1 ? 'day' : 'days'} ago`
    }

    if (duration.asMonths() < 1) {
      const weeks = Math.round(duration.asWeeks());
      return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`
    }

    if (duration.asYears() < 1) {
      const months = Math.round(duration.asMonths());
      return `${months} ${months === 1 ? 'month' : 'months'} ago`
    }

    const years = Math.round(duration.asYears());
    return `${years} ${years === 1 ? 'year' : 'years'} ago`
  }
}
